import { Box, Divider, Stack } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";
import { CampaignImageType } from "Infrastructure/Api/Api";
import { CampaignImageUpload } from "./CampaignImageUpload";
import { PreviewSection } from "./Preview/PreviewSection";
import { ThankYouSection } from "./ThankYouSection";
import type { Control, UseFormWatch } from "react-hook-form";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  formId: string;
  onSubmit: React.FormEventHandler;
  control: Control<CampaignFormData>;
  watch: UseFormWatch<CampaignFormData>;
  isSubmitting: boolean;
  campaignId: number;
};

export const ThankYouPageStep = ({
  formId,
  onSubmit,
  control,
  watch,
  isSubmitting,
  campaignId,
}: Props) => {
  const { t } = useResource();

  return (
    <PrimaryPaper>
      <Box
        display="grid"
        gridTemplateColumns={["1fr", "auto auto 1fr"]}
        gap={0}
        alignItems="start"
      >
        <Box
          id={formId}
          component="form"
          onSubmit={onSubmit}
          sx={{ minWidth: 230 }}
        >
          <Stack gap={4}>
            <CampaignImageUpload
              campaignId={campaignId}
              imageType={CampaignImageType.ThankYou}
              label={t(RESOURCES.ThankYouImage)}
              placeholder={
                <Box sx={{ width: 1, height: 1, bgcolor: "grey.300" }} />
              }
            />
            <ThankYouSection
              control={control}
              watch={watch}
              isSubmitting={isSubmitting}
            />
          </Stack>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ mx: 7 }} />
        <PreviewSection
          campaignId={campaignId}
          variant="thank-you-page"
          formValues={watch()}
        />
      </Box>
    </PrimaryPaper>
  );
};
